import { RecipientActionsType } from './interface';

export const RECIPIENT_TYPES = [
  {
    label: 'Email',
    value: 'email'
  },
  {
    label: 'Slack',
    value: 'slack'
  }
];

export const ACTION_ICON_MAP: {
  [key in Exclude<RecipientActionsType, RecipientActionsType.ADD>]?: string;
} = {
  [RecipientActionsType.SWITCH]: 'switch',
  [RecipientActionsType.DELETE]: 'delete',
  [RecipientActionsType.EDIT]: 'edit'
};

export const PROFILE_IMAGE =
  'https://res.cloudinary.com/hevo/image/upload/v1661186304/dashboard/profile-image-default_oeutti.svg';
